import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImage.js";  // ✅ CORRECTO
import { Button } from "flowbite-react";

const ImageCropper = ({ imageSrc, onCropComplete, onCancel }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const handleCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleSave = async () => {
    const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
    onCropComplete(croppedImage);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50">
      <div className="bg-white p-4 rounded-lg shadow-lg relative w-[90%] max-w-lg">
        <h2 className="text-center text-lg font-bold">Ajustar Imagen</h2>

        <div className="relative w-full h-64 mt-4">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={1} // Relación de aspecto cuadrada
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={handleCropComplete}
          />
        </div>

        <div className="flex justify-between mt-4">
          <Button onClick={onCancel} color="failure">
            Cancelar
          </Button>
          <Button onClick={handleSave} color="success">
            Guardar Recorte
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImageCropper;
